
/*
* @Author: zhengxiaowen
* @Date: 2019-02-25 11:02:01
* @Last Modified by: zhengxiaowen
* @Last Modified time: 2019-12-19 14:50:56
*/


import store from '../../store/StoreCommon'
import service from '../service'
import systemHook from '@/config/systemHook'
import jquery from 'jquery'
import Toast from 'vux/src/components/toast/index.vue'



let nativeApi = {}


nativeApi.createListen = function (_this) {
document.addEventListener('message', function (e) {
if(!e.data) return
try {

let msg = null 
if(typeof e.data === 'object'){
msg = e.data
}else{
msg = e.data ? JSON.parse(e.data) : {}
}
if (msg.nativeType === 'H5Init') {
nativeApi.RNH5Init(_this,msg)
}  else if (nativeApi.nativeFN[msg.nativeType]) {
let {nativeType, id, data} = msg
nativeApi.executeTransaction(nativeType, id, data)
}else if(msg.nativeType === 'RnRunH5Function'){
let {nativeType, id, data} = msg
nativeApi.RNExecuteTransaction(nativeType, id, data)
} else {
setTimeout(()=>{
alert(msg.nativeType+",H5 SDK没有该接口")
},500)
}













} catch (error) {
setTimeout(()=>{

nativeApi.nativeFN.RNConsole({msg:"message 初始化异常",errpr:error,data:e.data})
},500)
}
})
}


nativeApi.RNH5Init = function(_this,msg){


if(msg.data.userInfo) localStorage.setItem('userInfo', JSON.stringify(msg.data.userInfo))
if(msg.data.deviceInfo) localStorage.setItem('deviceInfo', JSON.stringify(msg.data.deviceInfo))
if(msg.data.webviewKey) localStorage.setItem('webviewKey', JSON.stringify(msg.data.webviewKey))

_this.$store.commit('INIT_USER_INFO')
_this.$store.commit('INIT_DEVICE_INFO')
_this.$store.commit('INIT_WEBVIEW_KEY')

nativeApi.router(_this)
}

nativeApi.H5Init = function(_this){
_this.$store.commit('INIT_USER_INFO')
_this.$store.commit('INIT_DEVICE_INFO')
_this.$store.commit('INIT_WEBVIEW_KEY')
nativeApi.router(_this)
}




nativeApi.router = function (_this) {
try {
sessionStorage.removeItem('routerName')
sessionStorage.removeItem('routerPath')
let params = _this.$route.query.params ? JSON.parse(_this.$route.query.params) : {}
let query = _this.$route.query.query ? JSON.parse(_this.$route.query.query) : {}


if (_this.$route.query.url) {
_this.$router.push(_this.$route.query.url)
} else if(_this.$route.query.routerName){
sessionStorage.routerName = _this.$route.query.routerName
_this.$router.push({
name: _this.$route.query.routerName,
params: params,
query: query
})
}else if(_this.$route.query.routerPath){
sessionStorage.routerPath = _this.$route.query.routerPath
_this.$router.push({
path: _this.$route.query.routerPath,
params: params,
query: query
})
}else{
if(store.state.system.isNative){
setTimeout(()=>{
alert('url必须带路由参数，或者没转encode导致错误')
},500)
}
}

} catch (error) {
setTimeout(()=>{
alert('url参数配置有误')
},500)
}


}




nativeApi.nativeFN = {}



nativeApi.nativeFN.H5Ready = function (data) {
let msg = {
nativeType: 'H5Ready',
data: data
}
nativeApi.postMessage(msg)
}



nativeApi.nativeFN.RNConsole = function (data) {
let msg = {
nativeType: 'RNConsole',
data: data
}
nativeApi.postMessage(msg)
}



nativeApi.nativeFN.RNGoBack = function (data) {
let msg = {
nativeType: 'RNGoBack',
data: data
}
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.TakePhoto = function (fn) {
nativeApi.nativeFN.RNConsole({fn:fn,type:'fn'})
let msg = nativeApi.initParams('TakePhoto', fn)
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.UploadPhoto = function (fn) {
let msg = nativeApi.initParams('UploadPhoto', fn)
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.GetGps = function (fn) {
let msg = nativeApi.initParams('GetGps', fn)
nativeApi.postMessage(msg)
}


nativeApi.nativeFN.OpenWechat = function (appUrl) {
let msg = {
nativeType: 'OpenApp',
data: {
appName: '微信',
appUrl: 'weixin://'+appUrl
}
}
nativeApi.postMessage(msg)
}







nativeApi.initParams = function (nativeType, fn) {
return {

id: fn ? nativeApi.addTransaction(nativeType, fn) : null,
data: null,
nativeType: nativeType
}
}


nativeApi.postMessage = function (msg) {

if (!store.state.system.isNative) {
return
}
try {
window.postMessage(JSON.stringify(msg))
} catch (error) {

}
try {
window.ReactNativeWebView.postMessage(JSON.stringify(msg))
} catch (error) {

}
}


nativeApi.transactions = {}

nativeApi.addTransaction = function (nativeType, fn) {
const id = new Date().getTime()
nativeApi.transactions[`${nativeType}(${id})`] = fn
return id
}

nativeApi.executeTransaction = function (nativeType, id, data) {

if (nativeApi.transactions[`${nativeType}(${id})`]) {
nativeApi.transactions[`${nativeType}(${id})`](data)
delete transactions[`${nativeType}(${id})`]
}
}





nativeApi.initRnRunH5Function = function(funs){
for(let key in funs){
nativeApi.transactions[`RnRunH5Function(${key})`] = funs[key]
}

}

nativeApi.RNExecuteTransaction = async function(nativeType, id, data){

if(nativeApi.transactions[`${nativeType}(${id})`]){
let d = await nativeApi.transactions[`${nativeType}(${id})`](data)
let msg = {
nativeType: 'RnRunH5Function',
id:id,
data: d,
status: "S"
}
nativeApi.postMessage(msg)
}else{
let msg = {
nativeType: 'RnRunH5Function',
id:id,
data: {msg:id+"h5对应的函数未被创建"},
status: "E"
}
nativeApi.postMessage(msg)
}
}




nativeApi.customApi = {}
nativeApi.customApi.addApi = (apiName)=>{
nativeApi.nativeFN[apiName] = function (data,fn) {
let msg = nativeApi.initParams(apiName, fn)
msg.data = data
nativeApi.postMessage(msg)
}
}

nativeApi.customApi.runApi = (apiName, data,fn)=>{
nativeApi.nativeFN[apiName](data,fn)
}

nativeApi.customApi.updateApi = (apiName,fun)=>{
nativeApi.nativeFN[apiName] = fun
}

nativeApi.customApi.removeApi = (apiName)=>{
delete nativeApi.nativeFN[apiName]
}

export default nativeApi


// WEBPACK FOOTER //
// ./src/common/tool/sdk2/nativeApi.js